// src/services/tikaneSenpService.js
import api from './api';

const BASE = '/tikanesenp';

export default {
  // Liste des comptes Ti Kanè Senp
  list: (params = {}) =>
    api
      .get(BASE, { params })
      .then(r => r.data),

  // Détail d’un compte
  get: (id) =>
    api
      .get(`${BASE}/${id}`)
      .then(r => r.data),

  // Création d’un compte
  create: (data) =>
    api
      .post(BASE, data)
      .then(r => r.data),

  // Mise à jour (statut, etc.)
  update: (id, data) =>
    api
      .put(`${BASE}/${id}`, data)
      .then(r => r.data),

  // Suppression
  remove: (id) =>
    api
      .delete(`${BASE}/${id}`)
      .then(r => r.data),
};
